function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { combineReducers } from 'redux';
import { routerReducer } from 'redux-first-routing';
import App from 'modules/App';
import Account from 'modules/Account';
import Information from 'modules/Information';
import Notifications from 'modules/Notifications';
import CloudDrive from 'modules/CloudDrive';
import DataSources from 'modules/DataSources';
import Hcp from 'modules/Hcp';
import Patient from 'modules/Patient';
import Statistics from 'modules/Statistics';
import ContourCloud from 'modules/ContourCloud';
import Mobile from 'modules/Mobile';
import Layout from 'modules/Layout';
/**
 * Here go all core non-dynamic reducers
 * @returns {{router: routerReducer}}
 */ export function getCoreReducers() {
    return {
        router: routerReducer,
        // loadingBar                        : loadingBarReducer,
        [App.constants.MODULE_ID]: App.reducer,
        [Account.constants.MODULE_ID]: Account.reducer,
        [Information.constants.MODULE_ID]: Information.reducer,
        [CloudDrive.constants.MODULE_ID]: CloudDrive.reducer,
        [DataSources.constants.MODULE_ID]: DataSources.reducer,
        [Hcp.constants.MODULE_ID]: Hcp.reducer,
        [Notifications.constants.MODULE_ID]: Notifications.reducer,
        [Patient.constants.MODULE_ID]: Patient.reducer,
        [Statistics.constants.MODULE_ID]: Statistics.reducer,
        [ContourCloud.constants.MODULE_ID]: ContourCloud.reducer,
        [Mobile.constants.MODULE_ID]: Mobile.reducer,
        [Layout.constants.MODULE_ID]: Layout.reducer
    };
}
export default function createReducer(asyncReducers = {}) {
    const coreReducers = getCoreReducers();
    return combineReducers(_object_spread({}, coreReducers, asyncReducers));
}
